import { BLUE_F, GREY_B, PURE_WHITE } from 'app/constants/Colors';
import { parseHex, toHexRgb, hsvToRgb, rgbToHsv, getWeightedBrightness } from 'app/utils/colors';
import { usePresenceContext } from 'app/containers/rtc/PresenceContext';
import { useRtcState } from 'app/containers/rtc/RtcStateContext';
import { useMemo } from 'react';

export function getNthColor(n: number): string {
  // Fallback to blue if BLUE_F doesn't parse for some reason
  const startHue = rgbToHsv(parseHex(BLUE_F) || { red: 0, blue: 1, green: 0, alpha: 1 }).hue;

  return toHexRgb(hsvToRgb({
    // Adding a prime number will make sure that hue only repeats
    // after 67 loops
    hue: (startHue + n * 67) % 360,
    // Darken every 30 loops, down to 0.5
    value: 1 - Math.min(0.5, (Math.floor(n / 30) * 0.1)),
    saturation: 1,
    alpha: 1,
  }));
}

export const useCallerColor = () => {
  const presence = usePresenceContext();
  const { caller } = useRtcState();
  const callerId = caller?.id;

  return useMemo(() => {
    if (!callerId) {
      return undefined;
    }

    const joinOrder = presence.getJoinOrder(callerId);

    return joinOrder >= 0 ? getNthColor(joinOrder) : undefined;
  }, [callerId, presence]);
};

export function getFlagLabelTextColor(background: string) {
  return (
    getWeightedBrightness(background) > 0.5
    ? GREY_B
    : PURE_WHITE
  );
}
